import { Location } from 'react-router-dom';

export function hasMongoObjectId(location: Location): boolean {
  const objectIdRegex = /\b[a-fA-F0-9]{24}\b/;
  return objectIdRegex.test(location.pathname);
}
